import { RootState } from 'data/types/state';

export const getCurrentUserState = (state: RootState) => state.user;
export const getCurrentStoreState = (state: RootState) => state.store;
export const getCurrentOrdersState = (state: RootState) => state.orders;

export const getCurrentStore = (state: RootState) => state.store.currentStore;
